export default "__VITE_ASSET__DxQvdWZI__"